<template>
  <div class="tmSearch contentBack">
      
      <!-- <router-view /> -->

    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>商标管理</el-breadcrumb-item>
      <el-breadcrumb-item class="breadSelected">商标查询 </el-breadcrumb-item>
    </el-breadcrumb>
    <div>
      <div class="listTitle titleBold gjcx">
        高级查询
        <span @click="handlegjcxShow">[展开/收起]</span>
      </div>
      <div class="gjcxContent" v-if="gjcxShow">
        <el-form
          ref="form"
          :model="form"
          label-width="82px"
          label-position="left"
        >
          <!-- 第一行 -->
          <div style="display: flex; justify-content: space-between">
            <el-form-item class="elform30" label="申请人：" size="mini">
              <el-input
                v-model="form.ap"
                placeholder="输入申请人名称"
                prefix-icon="el-icon-search"
                @change="applicantSearch()"
              ></el-input>
            </el-form-item>
                  <!-- 模糊查询结果 -->
          <div class="startFirms-new" v-if="startFirms">
      
          <ul>
            <li
              v-for="(item, index) of firms"
              :key="index"
              @click="chooseKeyfirm(index)"
            >
              {{ item.ap }}
            </li>
          </ul>
        </div>
            <el-form-item class="elform30" label="商标号：" size="mini">
              <el-input v-model="form.an" placeholder="输入商标号"></el-input>
            </el-form-item>
            <el-form-item class="elform30" label="商标名称：" size="mini">
              <el-input v-model="form.ti" placeholder="输入商标名称"></el-input>
            </el-form-item>
          </div>
          <!-- 第二行 -->
          <div style="display: flex; justify-content: space-between">
            <el-form-item label="申请日：" size="mini" style="width: 30%">
              <el-row>
                <!-- span的值为24 -->
                <el-col :span="11">
                  <el-date-picker
                    type="date"
                    placeholder="年/月/日"
                    v-model="form.sapd"
                    style="width: 100%"
                    value-format="yyyy-MM-dd"
                  ></el-date-picker>
                </el-col>
                <el-col :span="2"> 至 </el-col>
                <el-col :span="11">
                  <el-date-picker
                    type="date"
                    placeholder="年/月/日"
                    v-model="form.eapd"
                    style="width: 100%"
                    value-format="yyyy-MM-dd"
                  ></el-date-picker>
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item label="初审日：" size="mini" style="width: 30%">
              <el-row>
                <!-- span的值为24 -->
                <el-col :span="11">
                  <el-date-picker
                    type="date"
                    placeholder="年/月/日"
                    v-model="form.spd"
                    style="width: 100%"
                    value-format="yyyy-MM-dd"
                  ></el-date-picker>
                </el-col>
                <el-col :span="2"> 至 </el-col>
                <el-col :span="11">
                  <el-date-picker
                    type="date"
                    placeholder="年/月/日"
                    v-model="form.epd"
                    style="width: 100%"
                    value-format="yyyy-MM-dd"
                  ></el-date-picker>
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item label="注册日：" size="mini" style="width: 30%">
              <el-row>
                <!-- span的值为24 -->
                <el-col :span="11">
                  <el-date-picker
                    type="date"
                    placeholder="年/月/日"
                    v-model="form.sgd"
                    style="width: 100%"
                    value-format="yyyy-MM-dd"
                  ></el-date-picker>
                </el-col>
                <el-col :span="2"> 至 </el-col>
                <el-col :span="11">
                  <el-date-picker
                    type="date"
                    placeholder="年/月/日"
                    v-model="form.egd"
                    style="width: 100%"
                    value-format="yyyy-MM-dd"
                  ></el-date-picker>
                </el-col>
              </el-row>
            </el-form-item>
          </div>

          <!-- 第三行 -->
          <div
            style="display: flex; justify-content: space-between;"
          >
            <el-form-item label="国际分类：" style="width: 30%">
              <el-select v-model="form.ic" style="display: flex">
                <el-option
                  v-for="(item, index) of interType"
                  :key="index"
                  :label="item"
                  :value="item.split(' ')[0]"
                ></el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item label="重点产业：" style="width: 30%">
              <el-select v-model="form.zdcy" style="display: flex">
                <el-option label="全部" value="全部产业"></el-option>
                <el-option label="电子信息" value="电子信息"></el-option>
                <el-option label="装备制造" value="装备制造"></el-option>
                <el-option label="生物医药" value="生物医药"></el-option>
                <el-option label="能源化工" value="能源化工"></el-option>
              </el-select>
            </el-form-item> -->
             <el-form-item label="行业分类：" style="width: 30%">
              <el-select v-model="form.hyfl" style="display: flex">
                <el-option label="全部行业" value="全部行业"></el-option>
                <el-option v-for="(item,index) of industryType" :key="index" :label="item.label" :value="item.label"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="elform30" label="商标数量：" size="mini">
              <el-input style="width:45%"
                v-model="form.tmNumStart"
                placeholder="请输入数字"
                
              ></el-input> 至 
                <el-input style="width:45%"
                v-model="form.tmNumEnd"
                placeholder="请输入数字"
                
              ></el-input>
            </el-form-item>
          </div>
         

          <!-- 选择区域 -->
          <el-form-item label="企业分类：">
            <div style="display: flex">
              <el-checkbox
                v-model="checkAll1"
                @change="handleCheckAllChange1"
                style="margin-right: 30px"
                >全选</el-checkbox
              >
              <el-checkbox-group
                v-model="form.qyfl"
                @change="handleCheckedCompanyChange1"
              >
                <el-checkbox label="规上企业" name="qyfl"></el-checkbox>
                <el-checkbox label="专精特新企业" name="qyfl"></el-checkbox>
                <el-checkbox label="高新技术企业" name="qyfl"></el-checkbox>
                <el-checkbox label="融合发展企业" name="qyfl"></el-checkbox>
              </el-checkbox-group>
            </div>
          </el-form-item>
          <el-form-item label="品牌类型：">
            <div style="display: flex">
              <el-checkbox
                v-model="checkAll2"
                @change="handleCheckAllChange2"
                style="margin-right: 30px"
                >全选</el-checkbox
              >
              <el-checkbox-group
                v-model="form.brandType"
                @change="handleCheckedCompanyChange2"
              >
                <el-checkbox label="20" name="brandType">普通商标</el-checkbox>
                <el-checkbox label="1" name="brandType">地理标志商标</el-checkbox>
                <el-checkbox label="11" name="brandType">驰名商标</el-checkbox>
                <el-checkbox label="3" name="brandType">集体商标</el-checkbox>
                <el-checkbox label="15" name="brandType"
                  >中华老字号</el-checkbox
                >
              </el-checkbox-group>
            </div>
          </el-form-item>
          <el-form-item label="申请人类型：" class="sqrlx">
            <div style="display: flex">
              <el-checkbox
                v-model="checkAll4"
                @change="handleCheckAllChange4"
                style="margin-right: 30px"
                >全选</el-checkbox
              >
              <el-checkbox-group
                v-model="form.apty"
                @change="handleCheckedCompanyChange4"
              >
                <el-checkbox label="1" name="apty">工矿企业</el-checkbox>
                <el-checkbox label="2" name="apty">科研单位</el-checkbox>
                <el-checkbox label="3" name="apty">大专院校</el-checkbox>
                <el-checkbox label="4" name="apty">机关团体</el-checkbox>
                <el-checkbox label="5" name="apty">个人</el-checkbox>
              </el-checkbox-group>
            </div>
          </el-form-item>
          <el-form-item label="法律状态：">
            <div style="display: flex">
              <el-checkbox
                v-model="checkAll3"
                @change="handleCheckAllChange3"
                style="margin-right: 30px"
                >全选</el-checkbox
              >
              <el-checkbox-group
                v-model="form.ls"
                @change="handleCheckedCompanyChange3"
              >
                <el-checkbox label="1" name="ls">在审</el-checkbox>
                <el-checkbox label="2" name="ls">有效</el-checkbox>
                <el-checkbox label="3" name="ls">无效</el-checkbox>
              </el-checkbox-group>
            </div>
          </el-form-item>
          <el-form-item label="行政区域：">
            <div style="display: flex">
              <el-checkbox
                v-model="checkAll5"
                @change="handleCheckAllChange5"
                style="margin-right: 30px"
                >全选</el-checkbox
              >
              <el-checkbox-group
                v-model="form.cnty"
                @change="handleCheckedCompanyChange5"
              >
                <el-checkbox
                  v-for="(region, index) of regions"
                  :key="index"
                  :label="region"
                ></el-checkbox>
              </el-checkbox-group>
            </div>
          </el-form-item>

          <!-- <el-form-item label="战略新兴产业分类：" label-width="130px" >
            <div style="display: flex">
              <el-checkbox
                v-model="checkAll6"
                @change="handleCheckAllChange6"
                style="margin-right: 30px"
                >全选</el-checkbox
              >
           

               <el-checkbox-group
                v-model="form.StrategicNew"
                @change="handleCheckedCompanyChange6"
              >
                <el-checkbox
                  label="新一代信息技术产业"
                  name="apty"
                ></el-checkbox>
                <el-checkbox label="新材料产业" name="apty"></el-checkbox>
                <el-checkbox label="生物产业" name="apty"></el-checkbox>
                <el-checkbox label="新能源产业" name="apty"></el-checkbox>
                <el-checkbox label="数字创意产业" name="apty"> </el-checkbox>
                <el-checkbox label="高端装备制造产业" name="apty"></el-checkbox>
                <el-checkbox label="新能源汽车产业" name="apty"></el-checkbox>
                <el-checkbox label="节能环保产业" name="apty"></el-checkbox>
                <el-checkbox label="相关服务业" name="apty"> </el-checkbox>
              </el-checkbox-group>


            </div>
          </el-form-item> -->

          <!-- 按钮 -->
          <el-form-item label-width="0">
            <el-button
              style="background: #1890ff; padding: 10px 24px"
              type="primary"
              @click="onSubmit2"
              >查 询</el-button
            >
            <el-button
              style="padding: 10px 24px; margin-left: 46px"
              @click="resetData"
              >重 置</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <!-- 查询结果 -->
      <div v-if="isSearch">
        <div class="listTitle titleBold gjcx">
          查询结果

               <div class="out-excel" style="flex:1;">
         <el-button
            style="
              float: right;
              margin-right: 20px;
              height: 30px;
              line-height: 30px;
              padding: 0 16px;
              border-radius: 2px;
              margin-top: 2px;
              border: 1px solid #1773d5;
              color: #1773d5;
            "
            @click="daochu"
            >导出全部</el-button>
                          <el-button
            style="
              float: right;
              margin-right: 20px;
              height: 30px;
              line-height: 30px;
              padding: 0 16px;
              border-radius: 2px;
              margin-top: 2px;
              border: 1px solid #1773d5;
              color: #1773d5;
            "
            @click="daochu"
            >导出已选</el-button> 
       </div>
        </div>
        <div class="cxResultContent">
          <!-- 数据汇总 -->
          <table></table>
          <div style="margin: 11px 20px; font-size: 14px; color: #000">
            查询结果中，商标共<span class="bloooo">{{
              dataSummary.tmTotal
            }}</span>
            有效商标<span class="bloooo">{{ dataSummary.validNum }}</span
            >件，驰名商标<span class="bloooo">{{ dataSummary.famousNum }}</span
            >件，地理标志商标（累计）<span class="bloooo">{{
              dataSummary.landMarkNum
            }}</span
            >件。
          </div>
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
            border
            @sort-change="sort"
          >
            <!-- 选择框 -->
            <el-table-column :resizable="false" type="selection" width="40"> </el-table-column>
            <!-- 序号 -->
            <el-table-column :resizable="false"
              label="序号"
              type="index"
              width="50"
            >
             <template slot-scope="scope">
                <span>{{(pageNum - 1) * pageSize + scope.$index + 1}}</span>
            </template>
            </el-table-column>
            <!-- 商标号 点击跳转详情页-->
            <el-table-column :resizable="false" prop="an" label="商标号" min-width="45">
              <template slot-scope="scope">
                <div class="apStyle" @click="openDetails(scope.row)">
                  {{ scope.row.an }}
                </div>
              </template>
            </el-table-column>
            <!-- 商标名称 -->
            <el-table-column :resizable="false"
              prop="ti"
              label="商标名称"
              min-width="80"
              show-overflow-tooltip
            >
            </el-table-column>
              <!-- 申请人 -->
            <el-table-column :resizable="false"
              prop="ap"
              label="申请人"
              min-width="80"
              show-overflow-tooltip=""
            >
            </el-table-column>
            <!-- 国际分类 -->
            <el-table-column :resizable="false"
              prop="ic"
              label="国际分类"
              show-overflow-tooltip
            ></el-table-column>

            <!-- 申请日 -->
            <el-table-column :resizable="false"
              prop="apd"
              sortable="custom"
              label="申请日"
              min-width="60"
            ></el-table-column>
            <!-- 初审日 -->
            <el-table-column :resizable="false"
              prop="pd"
              sortable="custom"
              label="初审日"
              min-width="60"
            ></el-table-column>
            <!-- 注册日 -->
            <el-table-column :resizable="false"
              prop="gd"
              sortable="custom"
              label="注册日"
              min-width="60"
            ></el-table-column>
            <!-- 专用权期限  修改-->
            <el-table-column :resizable="false"
              prop="ed"
              label="专用权期限"
              min-width="50"
            ></el-table-column>
            <!-- 法律状态 -->
            <el-table-column :resizable="false"
              prop="ls"
              label="法律状态"
              min-width="50"
            ></el-table-column>
          </el-table>
        </div>
      </div>
      <!-- 分页 -->
      <div  v-if="isSearch" class="page-pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          ref="paginations"
        >
        </el-pagination>
       <el-button size="mini" type="primary" style="margin-left:5px">确定</el-button>
      </div>
      <!-- 商标基本信息弹框 -->

      <!-- 商标基本信息弹框结束 -->
    </div>
  </div>
</template>
<script>
export default {
  name:"tdemarkSearch",
  data() {
    return {
       startFirms: false, //模糊查询结果
       firms:[],
      gjcxShow: true,
      formcopy: {},
        industryType: [
            {
              id: 8,
              label: "交通运输、仓储和邮政业",
            },
            {
              id: 9,
              label: "住宿和餐饮业",
            },
            {
              id: 10,
              label: "信息传输、软件和信息技术服务业",
            },
            {
              id: 11,
              label: "公共管理、社会保障和社会组织",
            },
            {
              id: 12,
              label: "农、林、牧、渔业",
            },
            {
              id: 13,
              label: "制造业",
            },
            {
              id: 14,
              label: "卫生和社会工作",
            },
            {
              id: 15,
              label: "居民服务、修理和其他服务业",
            },
            {
              id: 16,
              label: "建筑业",
            },
            {
              id: 17,
              label: "房地产业",
            },
            {
              id: 18,
              label: "批发和零售业",
            },
            {
              id: 19,
              label: "教育",
            },
            {
              id: 20,
              label: "文化、体育和娱乐业",
            },
            {
              id: 21,
              label: "水利、环境和公共设施管理业",
            },
            {
              id: 22,
              label: "电力、热力、燃气及水生产和供应业",
            },
            {
              id: 23,
              label: "科学研究和技术服务业",
            },
            {
              id: 24,
              label: "租赁和商务服务业",
            },
            {
              id: 25,
              label: "采矿业",
            },
            {
              id: 26,
              label: "金融业",
            },
          ],
      form: {
        ap: "", //申请人名
        an: "", // 商标号
        sapd: "", // 申请日1
        eapd: "", //申请日2
        spd: "", //初审日1
        epd: "", //初审日2
        sgd: "", //注册日1
        egd: "", //注册日2
        qyfl: [], //企业分类
        cnty: [], //行政区域
        zdcy: "", //重点产业
        apty: [], //申请人类型
        ls: [], // 法律状态
        brandType: [], //品牌类型
        ti: "", //商标名称
        ic: "", //国际分类
        hyfl: "",//行业分类
        tmNumStart:'', //商标数量
        tmNumEnd:'',
        // StrategicNew:[], //战略星星
        // uid: localStorage.getItem("uid"),
      },

      interType: [
        "全部类别",
        "01 化工原料",
        "02 油漆涂料",
        "03 化妆清洁",
        "04 工业油脂",
        "05 医疗药品",
        "06 五金器具",
        "07 机器机械",
        "08 手工用具",
        "09 电子电器",
        "10 医疗器械",
        "11 家用电器",
        "12 车船配件",
        "13 火器烟花",
        "14 珠宝饰品",
        "15 乐器乐辅",
        "16 文具办公",
        "17 橡塑制品",
        "18 皮具制品",
        "19 建筑材料",
        "20 家具工艺",
        "21 厨具日用",
        "22 绳缆帐篷",
        "23 线丝丝纺",
        "24 家用纺品",
        "25 服装鞋帽",
        "26 缝纫用品",
        "27 地毯席垫",
        "28 运动器械",
        "29 食品鱼肉",
        "30 食品佐料",
        "31 生鲜农产",
        "32 啤酒饮料",
        "33 酒精饮料",
        "34 烟草制品",
        "35 广告商业",
        "36 金融经纪",
        "37 修理安装",
        "38 通讯服务",
        "39 运输旅行",
        "40 加工服务",
        "41 教育娱乐",
        "42 科技研究",
        "43 餐饮住宿",
        "44 医疗美容",
        "45 法律安全",
      ],
      typeFirm: ["高新技术企业", "规上企业", "重点企业","融合发展企业","专精特新企业"],
      Ptype: ["20", "1", "11", "3", "15"],
      lawtype: ["1", "2", "3"],
      applytype: ["1", "2", "3", "4", "5"],
      zlxxtype: [
        "新一代信息技术产业",
        "新材料产业",
        "生物产业",
        "新能源产业",
        "数字创意产业",
        "高端装备制造产业",
        "新能源汽车产业",
        "节能环保产业",
        "相关服务业",
      ],
      regions: [],
      checkAll1: false,
      checkAll2: false,
      checkAll3: false,
      checkAll4: false,
      checkAll5: false,
      checkAll6: false,
      order: "",
      orderType: "", //排序方式
      pageNum: 1,
      pageSize: 10,
      isSearch: false,
      //   数据汇总
      dataSummary: [],
      tableData: [],
      currentPage: 1,
      total: 0,
      multipleSelection: [],
      zldetails: false,
      sbbasicDataDetails: {},
      isSubmit: false,
    };
  },
  methods: {
       // 申请人模糊查询
    applicantSearch(){
      this.$GET('applicant/searchField' ,{
        keyword:this.form.ap,
        pageNum:this.pageNum,
        pageSize:this.pageSize
      }).then((res) => {
        this.firms = res.data.list
       if(this.firms.length === 0){
           this.startFirms = false
         } else {
            this.startFirms = true
         }
     
      })
    },
    chooseKeyfirm(index) {
      this.form.ap = this.firms[index].ap;
      this.startFirms = false;
    },
    handlegjcxShow() {
      this.gjcxShow = this.gjcxShow ? false : true;
    },
    // 选择企业分类
    handleCheckedCompanyChange1(value) {
      this.checkAll1 = value.length == this.typeFirm.length;
    },
    handleCheckAllChange1(value) {
      value ? (this.form.qyfl = this.typeFirm) : (this.form.qyfl = []);
    },
    // 选择品牌类型
    handleCheckedCompanyChange2(value) {
      this.checkAll2 = value.length == this.Ptype.length;
    },
    handleCheckAllChange2(value) {
      value ? (this.form.brandType = this.Ptype) : (this.form.brandType = []);
      // console.log(this.form.type)
    },
    // 选择法律状态
    handleCheckedCompanyChange3(value) {
      this.checkAll3 = value.length == this.lawtype.length;
    },
    handleCheckAllChange3(value) {
      value ? (this.form.ls = this.lawtype) : (this.form.ls = []);
    },
    // 选择申请人类型
    handleCheckedCompanyChange4(value) {
      this.checkAll4 = value.length == this.applytype.length;
    },
    handleCheckAllChange4(value) {
      value ? (this.form.apty = this.applytype) : (this.form.apty = []);
    },
    // 选择行政区域
    handleCheckedCompanyChange5(value) {
      this.checkAll5 = value.length == this.regions.length;
    },
    handleCheckAllChange5(value) {
      value ? (this.form.cnty = this.regions) : (this.form.cnty = []);
    },
      // 选择战略新兴区域 待修改
    // handleCheckedCompanyChange6(value) {
    //   this.checkAll6 = value.length == this.zlxxtype.length;
    // },
    // handleCheckAllChange6(value) {
    //   value ? (this.form.StrategicNew = this.zlxxtype) : (this.form.StrategicNew = []);
    // },
    // 查询和重置
    onSubmit2() {
      this.isSubmit = true;
      this.formcopy = JSON.parse(JSON.stringify(this.form));
      this.pageSize = 10;
      this.pageNum = 1;
      this.currentPage = 1;
      this.dataSummary = [];
      this.multipleSelection = [];
      if (this.order!=='') {
        this.resetSort();
      }
      this.onSubmit();
    },
    // 商标高级查询
    onSubmit() {
      if(this.formcopy.ic=="全部类别") {
        this.formcopy.ic = ''
      }
      this.$GET("/trademark/search", {
        ap: this.formcopy.ap,
        an: this.formcopy.an,
        sapd: this.formcopy.sapd,
        eapd: this.formcopy.eapd,
        spd: this.formcopy.spd,
        epd: this.formcopy.epd,
        sgd: this.formcopy.sgd,
        egd: this.formcopy.egd,
        qyfl: this.formcopy.qyfl.join(";"),
        brandType: this.formcopy.brandType.join(";"),
        apty: this.formcopy.apty.join(";"),
        ls: this.formcopy.ls.join(";"),
        cnty: this.formcopy.cnty.join(";"),
        zdcy: this.formcopy.zdcy,
        ti: this.formcopy.ti,
        ic: this.formcopy.ic,
        hyfl:this.formcopy.hyfl,
        tmNumStart:this.form.tmNumStart,
        tmNumEnd:this.form.tmNumEnd,
        // StrategicNew:this.formcopy.StrategicNew.join(";"),
        order: this.order,
        orderType: this.orderType,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        
        // uid: this.uid
      }).then((res) => {
        // console.log('----',res)
        this.isSubmit = false;
        this.isSearch = true;
        this.gjcxShow = false;
        if (this.dataSummary.length == 0) {
          this.dataSummary = res.data.countMap;
        }
        this.tableData = res.data.data.records;
        this.total = res.data.data.total;
        this.tableData.forEach((ele) => {
          if (ele.apd !== null) {
            ele.apd = ele.apd.split(" ")[0];
          }
          if (ele.pd !== null) {
            ele.pd = ele.pd.split(" ")[0];
          }
          if (ele.gd !== null) {
            ele.gd = ele.gd.split(" ")[0];
          }
          if (ele.ls == "1") {
            ele.ls = "在审";
          } else if (ele.ls == "2") {
            ele.ls = "有效";
          } else if (ele.ls == "3") {
            ele.ls = "无效";
          }
        });
      });
    },
    resetData() {
      (this.form.ap = ""), //申请人名
        (this.form.an = ""), // 商标号
        (this.form.sapd = ""), // 申请日1
        (this.form.eapd = ""), //申请日2
        (this.form.spd = ""), //初审日1
        (this.form.epd = ""), //初审日2
        (this.form.sgd = ""), //注册日1
        (this.form.egd = ""), //注册日2
        (this.form.qyfl = []), //企业分类
        (this.form.cnty = []), //行政区域
        (this.form.zdcy = ""), //重点产业
        (this.form.apty = []), //申请人类型
        (this.form.ls = []), // 法律状态
        (this.form.brandType = []), //品牌类型
        (this.form.ti = ""), //商标名称
        (this.form.ic = ""), //国际分类
        (this.ipcValue = []);
      this.locValue = [];
      this.form.hyfl='';
      this.form.tmNumStart=''; //商标数量
      this.form.tmNumEnd='';
      this.checkAll1= false;
      this.checkAll2= false;
      this.checkAll3= false;
      this.checkAll4= false;
      this.checkAll5= false;
      this.checkAll6= false;
    },
    // 重置排序
    resetSort() {
      this.$refs.multipleTable.sort(this.order, null);
    },
    // 导出
    daochu() {
      if (this.multipleSelection.length > 0) {
        var rids = [];
        this.multipleSelection.forEach((ele) => {
          rids.push(ele.rid);
        });
        // 通过a 标签导出
        let aLink1 = document.createElement("a");
        let rid = rids.join(";");
        aLink1.href =
          this.$url +
          "/trademark/export?token=" +
          localStorage.getItem("token") +
          "&uid=" +
          localStorage.getItem("uid") +
          "&rids=" +
          rid;
        aLink1.click();
      } else if (this.multipleSelection.length == 0) {
        let qyfl = this.form.qyfl.join(";");
        let cnty = this.form.cnty.join(";");
        let apty = this.form.apty.join(";");
        let brandType = this.form.brandType.join(";");
        let ls = this.form.ls.join(";");
        let aLink2 = document.createElement("a");
        // let an = ans.join(";");
        aLink2.href =
          this.$url +
          "/trademark/export?token=" +
          localStorage.getItem("token") +
          "&uid=" +
          localStorage.getItem("uid") +
          "&ap=" +
          this.form.ap +
          "&an=" +
          this.form.an +
          "&sapd=" +
          this.form.sapd +
          "&eapd=" +
          this.form.eapd +
          "&spd=" +
          this.form.spd +
          "&epd=" +
          this.form.epd +
          "&sgd=" +
          this.form.sgd +
          "&egd=" +
          this.form.egd +
          "&qyfl=" +
          qyfl +
          "&cnty=" +
          cnty +
          "&zdcy=" +
          this.form.zdcy +
          "&apty=" +
          apty +
          "&hyfl=" +
          this.form.hyfl +
          "&brandType=" +
          brandType +
          "&ti=" +
          this.form.ti +
          "&ic=" +
          this.form.ic +
          "&ls=" +
          ls;
        aLink2.click();
      }
    },
    // 多选
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 排序
    sort(column) {
      if (!this.isSubmit) {
        this.order = column.prop;
        let orderType;
        if (column.order == "ascending") {
          orderType = "asc";
        } else if (column.order == "descending") {
          orderType = "desc";
        }
        this.orderType = orderType;
        this.onSubmit();
      }
    },
    // 分页
    handleSizeChange(value) {
      this.pageSize = value;
      this.onSubmit();
    },
    handleCurrentChange(value) {
      this.pageNum = value;
      this.onSubmit();
    },
    // 打开点击商标跳转商标详情页
    openDetails(row) {
      this.$router.push({
          path: "/TrademarkInfo",
        });
    this.sbbasicDataDetails = row;
    // console.log(this.sbbasicDataDetails)
     this.$store.commit("tdDataDetails", this.sbbasicDataDetails);
    },
    // 点击商标跳转商标详情页
    // closeTksb() {
    //   this.$rorter.push()
    // },
  },
  mounted() {
    let regions = JSON.parse(localStorage.getItem("DataPermission"));
    let regionName = [];
    regions.forEach((element) => {
      regionName.push(element.name);
    });
    this.regions = regionName;
  },
};
</script>
<style>
.tmSearch > div {
  height: 100%;
  overflow-y: auto;
}
.tmSearch .el-form--label-left .el-form-item__label {
  text-align: right;
}
.tmSearch .el-form-item__label {
  padding: 0;
  
}
.tmSearch .sqrlx .el-form-item__label {
  width: 86px !important;
}
/* .tmSearch .zlcyfl .el-form-item__label {
  width: 3.5rem !important;
} */
.tmSearch .el-form-item:not(.el-form-item--mini) {
  margin-bottom: 0;
}
.tmSearch .el-cascader-menu__list {
  max-width: 13vw !important;
}
.tmSearch .gjcxContent .el-form-item__content{
  text-align: center;
}

</style>